import { EmptystateHelmetColored } from "components/icons/generated";
import LinkButton from "ds/components/Button/LinkButton";
import EmptyState from "ds/components/EmptyState";

type PoliciesEmptyProps = {
  hasNoFilteringResults: boolean;
  canCreatePolicy: boolean;
};

const PoliciesEmpty = ({ hasNoFilteringResults, canCreatePolicy }: PoliciesEmptyProps) => (
  <>
    {hasNoFilteringResults && (
      <EmptyState
        title="No results"
        icon={EmptystateHelmetColored}
        caption="Try different filters."
        announce
      />
    )}
    {!hasNoFilteringResults && (
      <EmptyState
        title="You don't have any policies yet"
        icon={EmptystateHelmetColored}
        caption="Policies are declarative rules evaluated at various decision points within Spacelift. Create new policy from scratch using button above or start with one of our templates."
      >
        {canCreatePolicy && (
          <LinkButton variant="secondary" to="/policies-templates">
            Explore templates
          </LinkButton>
        )}
      </EmptyState>
    )}
  </>
);

export default PoliciesEmpty;
